var React = require('react');

function MenuBars (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".menu-bars-1{fill:#231f20;}")),React.createElement("path",{"className":"menu-bars-1","d":"M16.32,1.1A15.06,15.06,0,1,0,31.38,16.16,15.06,15.06,0,0,0,16.32,1.1Zm0,29.12A14.06,14.06,0,1,1,30.38,16.16,14.05,14.05,0,0,1,16.32,30.22Zm-9-13.72H24.66v-1H7.34Zm0,6.57H24.66v-1H7.34Zm0-13.14H24.66v-1H7.34Z","transform":"translate(-1.26 -1.1)","key":1})]);
}

MenuBars.defaultProps = {"viewBox":"0 0 30.12 30.12"};

module.exports = MenuBars;

MenuBars.default = MenuBars;
